import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3 px-4 md:px-6">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {isLast ? (
                <span className="text-foreground-600 font-medium">{item.label}</span>
              ) : item.to ? (
                <Link
                  to={item.to}
                  className="text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-500">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}